import React, { useState } from 'react';
import Style from './Writings.module.scss';
import { Box } from "@mui/material";

export default function Writings({innerRef}) {
    const [expanded, setExpanded] = useState({});

    const toggleExpand = (index) => {
        setExpanded(prev => ({ ...prev, [index]: !prev[index] }));
    };

    const writings = [
        {
            title: "My controlplane couldn't reach kube-apiserver",
            date: "15 March 2026",
            description: "Was messing around with my Kubernetes lab cluster today and kubectl just... stopped working. API server completely unreachable, control plane down. My first thought was that I'd somehow broken Kubernetes itself, which would've been a fun afternoon.\n Dug through the logs and turns out it was way simpler than that. The API server was crash-looping because it expected an encryption provider file for Secrets encryption at /var/lib/kubernetes/ — and the file wasn't there. So it just refused to start. Fair enough, honestly.\n The file wasn't even missing. It was sitting in /home/vagrant the whole time. Moved it to the right path, restarted the API server, and everything came back up like nothing happened.\n Classic. Spent way too long on what was basically a misplaced config file"
        },
        {
            title: "Setting up my OpenClaw...",
            date: "23 February 2026",
            description: "In the past couple of weeks, I turned my AI assistant from “just chat” into a real working system. What I actually did was set up a main assistant (Ultra) as my single point of contact. Built specialist agents for different types of tasks. Created a proper workflow so tasks are delegated and tracked, instead of me micromanaging everything. Added approval rules before any production push/redeploy. Enforced staging-first workflow before touching production. Deployed and maintained live web apps on my VPS (with PM2 + Nginx). Added authentication flow, environment-based secrets, and safer deployment routine. Built an internal agent dashboard to monitor roles, status, and recent activity. Added automated weekly GitHub backups. Improved system hygiene: disk cleanup, clearer workspace structure, better change control. Biggest takeaway for me is that AI gets truly useful when you treat it like operations — with structure, guardrails, and ownership — not just prompts."
        }
    ];

    return (
        <Box ref={innerRef} className={Style.container} id={'writings'}>
            <Box className={Style.header}>
                <h2 className={Style.title}>Writings</h2>
                <p className={Style.subtitle}>My internal thoughts....</p>
            </Box>
            <Box className={Style.content}>
                {writings.map((writing, index) => {
                    const isExpanded = expanded[index];
                    const words = writing.description.split(' ');
                    const halfLength = Math.ceil(words.length / 2);
                    const truncatedDescription = words.slice(0, halfLength).join(' ');
                    
                    return (
                        <Box key={index} className={Style.writingItem}>
                            <h3 className={Style.writingTitle}>{writing.title}</h3>
                            <h2 className={Style.writingDate}>{writing.date}</h2>
                            <p className={Style.writingDescription}>
                                {isExpanded ? writing.description : truncatedDescription}
                            </p>
                            <button 
                                className={Style.readMore} 
                                onClick={() => toggleExpand(index)}
                            >
                                {isExpanded ? 'Read less' : 'Read more'}
                            </button>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    )
}
